// src/pages/PainelChamados/CampoResponsavel.jsx
import React, { useState, useRef, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { ChevronDown } from "lucide-react";

const API_URL = process.env.REACT_APP_API_URL;

export default function CampoResponsavel({
  colaborador,
  setColaborador,
  tecnicoResponsavel,
  setTecnicoResponsavel,
}) {
  const [openSelect, setOpenSelect] = useState(false);
  const [tecnicos, setTecnicos] = useState([]);
  const refSelect = useRef(null);

  useEffect(() => {
    const handler = (e) => {
      if (refSelect.current && !refSelect.current.contains(e.target)) {
        setOpenSelect(false);
      }
    };
    document.addEventListener("mousedown", handler);
    return () => document.removeEventListener("mousedown", handler);
  }, []);

  useEffect(() => {
    const fetchTecnicos = async () => {
      try {
        const resp = await fetch(`${API_URL}/usuarios/listar.php`);
        const data = await resp.json();

        if (data.status === "success") {
          setTecnicos(data.dados);
        } else {
          setTecnicos([]);
        }
      } catch (err) {
        console.error("Erro ao carregar técnicos:", err);
        setTecnicos([]);
      }
    };

    fetchTecnicos();
  }, []);

  const tecnicosFiltrados = tecnicos.filter((t) =>
    t.nome.toLowerCase().includes(tecnicoResponsavel.toLowerCase())
  );

  const validarTecnico = () => {
    const valido = tecnicos.some(
      (t) => t.nome.toLowerCase() === tecnicoResponsavel.toLowerCase()
    );
    if (!valido) setTecnicoResponsavel("");
  };

  const inputBaseClasses = `
    peer w-full h-10 px-2 border-b border-gray-300
    focus:border-blue-600 focus:ring-0 focus:outline-none
    text-base text-gray-900 bg-transparent placeholder-transparent
  `;

  const labelBaseClasses = (value) => `
    absolute left-2 transition-all duration-200 pointer-events-none
    ${value ? "-top-4 text-sm font-bold text-gray-900" : "top-2 text-base text-gray-400"}
    peer-focus:-top-4 peer-focus:text-sm peer-focus:font-bold peer-focus:text-gray-900
  `;

  return (
    <>
      {/* Colaborador */}
      <div className="relative flex-1 min-w-[200px]">
        <input
          type="text"
          value={colaborador}
          onChange={(e) => setColaborador(e.target.value)}
          placeholder=" "
          className={inputBaseClasses}
        />
        <label className={labelBaseClasses(colaborador)}>Colaborador</label>
      </div>

      {/* Técnico Responsável */}
      <div className="relative flex-1 min-w-[160px] max-w-[240px]" ref={refSelect}>
        <input
          type="text"
          value={tecnicoResponsavel}
          onChange={(e) => {
            setTecnicoResponsavel(e.target.value);
            setOpenSelect(true);
          }}
          onBlur={validarTecnico}
          placeholder=" "
          className={inputBaseClasses + " cursor-text"}
        />
        <label className={labelBaseClasses(tecnicoResponsavel)}>
          Técnico Responsável
        </label>

        <ChevronDown
          size={16}
          onClick={() => setOpenSelect((prev) => !prev)}
          className={`absolute right-1 top-3 cursor-pointer transition-transform ${
            openSelect ? "rotate-180" : "rotate-0"
          }`}
        />

        <AnimatePresence>
          {openSelect && (
            <motion.ul
              initial={{ opacity: 0, y: -5 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0, y: -5 }}
              transition={{ duration: 0.2 }}
              className="absolute left-0 right-0 mt-1 bg-white border border-gray-300 
                         rounded-md shadow-md z-10 max-h-52 overflow-y-auto"
            >
              {tecnicosFiltrados.length > 0 ? (
                tecnicosFiltrados.map((t) => (
                  <li
                    key={t.id}
                    onMouseDown={() => {
                      setTecnicoResponsavel(t.nome);
                      setOpenSelect(false);
                    }}
                    className="px-3 py-2 text-sm text-gray-700 hover:bg-blue-100 cursor-pointer"
                  >
                    {t.nome}
                  </li>
                ))
              ) : (
                <li className="px-3 py-2 text-sm text-gray-500 italic">
                  Nenhum técnico encontrado
                </li>
              )}
            </motion.ul>
          )}
        </AnimatePresence>
      </div>
    </>
  );
}
